const MenuData = [
    {
        id: 1,
        title: "Fried Screw-Buns with Condensed Milk (4pcs)",
        cTitle: "炸螺絲卷",
        price: 3.16,
        category: "dumpling"
    },
    {
        id: 2,
        title: "Pan Fried Beef Dumplings (2pcs)",
        cTitle: "牛肉餡餅",
        price: 3.80,
        category: "dumpling"
    },
    {
        id: 3,
        title: "Pan Fried Marinated Beef Wraps (4pcs)",
        cTitle: "大餅夾牛肉",
        price: 6.00,
        category: "dumpling"
    },
    {
        id: 4,
        title: "Pan Fried Chive Dumplings (2pcs)",
        cTitle: "韭菜煎餅",
        price: 4.40,
        category: "dumpling"
    },
    {
        id: 5,
        title: "Pan Fried Pork Buns (3pcs)",
        cTitle: "生煎包",
        price: 3.96,
        category: "dumpling"
    },
    {
        id: 6,
        title: "Steamed Pork Soup Dumplings (6pcs)",
        cTitle: "小籠湯包",
        price: 6.00,
        category: "dumpling"
    },
    {
        id: 7,
        title: "Steamed Vegetable & Egg Dumplings (6pcs)",
        cTitle: "花素蒸餃",
        price: 7.16,
        category: "dumpling"
    },
    {
        id: 8,
        title: "Steamed Crab Meat & Pork Soup Dumplings (6pcs)",
        cTitle: "蟹黃小籠包",
        price: 10.00,
        category: "dumpling"
    },
    {
        id: 9,
        title: "Steamed XO Sauce & Pork Soup Dumplings (6pcs)",
        cTitle: "XO醬小籠包",
        price: 6.80,
        category: "dumpling"
    },
    {
        id: 10,
        title: "Steamed Fish Dumplings (6pcs)",
        cTitle: "鮮魚蒸餃",
        price: 7.16,
        category: "dumpling"
    },
    {
        id: 11,
        title: "Steamed Vegetable & Pork Dumplings (6pcs)",
        cTitle: "菜肉蒸餃",
        price: 7.16,
        category: "dumpling"
    },
    {
        id: 12,
        title: "Shrimp & Pork Shaomai (6pcs)",
        cTitle: "蝦仁燒賣",
        price: 7.16,
        category: "dumpling"
    },
    {
        id: 13,
        title: "Fried Noodles with Satay Beef",
        cTitle: "沙茶牛肉炒麵",
        price: 10.36,
        category: "noodles"
    },
    {
        id: 14,
        title: "Noodles with Sesame & Peanuts in Spicy Sauce",
        cTitle: "擔擔麵",
        price: 7.16,
        category: "noodles"
    },
    {
        id: 15,
        title: "Shanghai Fried Noodles",
        cTitle: "上海粗炒麵",
        price: 11.40,
        category: "noodles"
    },
    {
        id: 16,
        title: "Noodle Soup with Beef & Beef Tendon",
        cTitle: "紅燒半筋半肉麵",
        price: 10.36,
        category: "noodles"
    },
    {
        id: 17,
        title: "Noodle Soup with Beef",
        cTitle: "紅燒牛肉麵",
        price: 9.56,
        category: "noodles"
    },
    {
        id: 18,
        title: "Noodles with Homemade Meat Sauce",
        cTitle: "炸醬麵",
        price: 7.16,
        category: "noodles"
    },
    {
        id: 19,
        title: "Stir Fried Rice Cake with Pork Chop Shanghai Style",
        cTitle: "上海排骨年糕",
        price: 10.36,
        category: "noodles"
    },
    {
        id: 20,
        title: "Stir Fried Rice Noodles with Pork & Vegetable",
        cTitle: "炒米粉",
        price: 10.36,
        category: "noodles"
    },
    {
        id: 21,
        title: "Fried Homemade Noodles with Seafood & Pork",
        cTitle: "海鮮粗炒麵",
        price: 10.36,
        category: "noodles"
    },
    {
        id: 22,
        title: "Fried Rice with Shrimps, Vegetables & Hams",
        cTitle: "楊州炒飯",
        price: 11.16,
        category: "rice"
    },
    {
        id: 23,
        title: "Fried Rice with Beef & XO Sauce",
        cTitle: "X0醬牛肉炒飯",
        price: 11.16,
        category: "rice"
    },
    {
        id: 24,
        title: "Fried Rice with Vegetables, Salted Pork & Chinese Sausages",
        cTitle: "招牌菜飯",
        price: 11.16,
        category: "rice"
    },
    {
        id: 25,
        title: "Fried Rice with Shrimps",
        cTitle: "蝦仁炒飯",
        price: 11.16,
        category: "rice"
    },
    {
        id: 26,
        title: "Spicy Fried Rice with Seafood & Shredded Pork",
        cTitle: "海陸辣炒飯",
        price: 11.16,
        category: "rice"
    },
    {
        id: 27,
        title: "Fried Rice with Deep Fried Pork Chop",
        cTitle: "排骨炒飯",
        price: 12.76,
        category: "rice"
    },
    {
        id: 28,
        title: "Fried Rice with Dry Scallops & Egg White",
        cTitle: "瑤柱蛋白炒飯",
        price: 11.16,
        category: "rice"
    },
    {
        id: 29,
        title: "Fried Rice with Shredded",
        cTitle: "炒飯",
        price: 11.16,
        category: "rice"
    },
    {
        id: 30,
        title: "Fried Rice with Sakura Shrimps",
        cTitle: "櫻花蝦炒飯",
        price: 11.16,
        category: "rice"
    },
    {
        id: 31,
        title: "Cold Cucumbers in Garlic Sauce",
        cTitle: "涼拌小黃瓜",
        price: 5.56,
        category: "appetizer"
    },
    {
        id: 32,
        title: "Cold Wined Boneless Chicken",
        cTitle: "花雕醉雞",
        price: 6.36,
        category: "appetizer"
    },    
    {
        id: 33,
        title: "Vegetable & Pork Wontons with Hot & Sour Sauce",
        cTitle: "紅油菜肉餛飩",
        price: 7.16,
        category: "appetizer"
    },    
    {
        id: 34,
        title: "Wontons with Hot & Sour Sauce",
        cTitle: "紅油炒手",
        price: 6.36,
        category: "appetizer"
    },    
    {
        id: 35,
        title: "Deep Fried Tofu Pudding in Garlic Sauce",
        cTitle: "老皮嫩肉",
        price: 5.20,
        category: "appetizer"
    },    
    {
        id: 36,
        title: "Tofu & Preserved Egg in Soy Sauce",
        cTitle: "皮蛋豆腐",
        price: 5.56,
        category: "appetizer"
    },
    {
        id: 37,
        title: "Sweet & Sour Chicken",
        cTitle: "咕嚕雞",
        price: 12.76,
        category: "meat"
    },
    {
        id: 38,
        title: "Cashew Nut Chicken",
        cTitle: "腰果雞丁",
        price: 14.36,
        category: "meat"
    },
    {
        id: 39,
        title: "Gongbao Chicken",
        cTitle: "宮保雞丁",
        price: 14.36,
        category: "meat"
    },
    {
        id: 40,
        title: "Wok Fried Spareribs with Salt & Hot Pepper",
        cTitle: "椒鹽排骨",
        price: 14.36,
        category: "meat"
    },
    {
        id: 41,
        title: "Sweet & Sour Spareribs with Bell Peppers & Onion",
        cTitle: "糖醋排骨",
        price: 12.76,
        category: "meat"
    },
    {
        id: 42,
        title: "Honey Garlic Spareribs",
        cTitle: "蒜香蜜汁骨",
        price: 14.36,
        category: "meat"
    },
    {
        id: 43,
        title: "Stir Fried Shredded Beef & Green Onion with Soy Sauce",
        cTitle: "蔥爆牛肉",
        price: 13.56,
        category: "meat"
    },
    {
        id: 44,
        title: "Pan Fried Garlic Beef Steak",
        cTitle: "蒜香牛肉",
        price: 14.36,
        category: "meat"
    },
    {
        id: 45,
        title: "Stir Fried Beef with Black Bean Sauce",
        cTitle: "豉椒牛肉",
        price: 14.36,
        category: "meat"
    },
    {
        id: 46,
        title: "Coconut Tapioca",
        cTitle: "椰汁西米露",
        price: 3.40,
        category: "dessert"
    },
    {
        id: 47,
        title: "Malay Sponge Cake",
        cTitle: "馬來糕",
        price: 3.16,
        category: "dessert"
    },
    {
        id: 48,
        title: "Red Bean Paste Pancake",
        cTitle: "豆沙鍋餅",
        price: 7.60,
        category: "dessert"
    },
    {
        id: 49,
        title: "Steamed Glutinous Rice & Red Bean Paste Dumplings",
        cTitle: "麻糬豆沙小包",
        price: 5.20,
        category: "dessert"
    },
    {
        id: 50,
        title: "Steamed Mashed Taro Buns",
        cTitle: "芋泥包",
        price: 3.60,
        category: "dessert"
    },
    {
        id: 51,
        title: "Steamed Red Bean Paste Buns",
        cTitle: "豆沙包",
        price: 3.40,
        category: "dessert"
    },
    {
        id: 52,
        title: "Steamed Red Bean Paste Dumplings",
        cTitle: "豆沙小包",
        price: 3.40,
        category: "dessert"
    },
    {
        id: 53,
        title: "Steamed Salted Egg & Condensed Milk Buns",
        cTitle: "奶黃包",
        price: 3.60,
        category: "dessert"
    },
    {
        id: 54,
        title: "Steamed Sesame Paste Buns",
        cTitle: "芝麻包",
        price: 3.60,
        category: "dessert"
    }
];

export default MenuData;